import { render, staticRenderFns } from "./SubAssistanceOverlay.vue?vue&type=template&id=57867514&scoped=true"
import script from "./SubAssistanceOverlay.vue?vue&type=script&lang=js"
export * from "./SubAssistanceOverlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57867514",
  null
  
)

export default component.exports